/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { CssBaseline } from '@mui/material';
import GlobalStyle from 'modules/common/style/global';
import { Footer, JoyrideProvider, Navbar, SessionTimeOutPopup, TokenRevokedPopup } from 'modules/common/components';
import useUpdateToken from 'modules/common/hooks/use-update-token';
import { AppContent, MainContent, Root } from './style';
/**
 * Parent dashboard layout define here. And also define global hooks
 * App content wraps child components related to dashboard layout
 * @returns
 */
const DashboardLayout = () => {
  // Hook function to update refresh token and embed token
  useUpdateToken();
  //
  const [mobileOpen, setMobileOpen] = useState(false);
  // Handle open/close mobile drawer
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  //
  return (
    <Root>
      <JoyrideProvider/>
      <CssBaseline />
      <GlobalStyle />
      <AppContent>
        <Navbar onDrawerToggle={handleDrawerToggle} />
        <MainContent>
          <Outlet />
          <SessionTimeOutPopup />
          <TokenRevokedPopup />
        </MainContent>
        <Footer />
      </AppContent>
    </Root>
  );
};
//
export default DashboardLayout;
